import React, { useState, useEffect } from "react";
import './Home.css';
import {Navigation} from "./navigation";
import {Header} from "./header";
import About from "./about";
import { Services } from "./services";
import { Gallery } from "./gallery";
import { Team } from "./team";
import { Contact } from "./contact";
import jdata from "./data.json";
import SmoothScroll from "smooth-scroll";
import {Video} from "./video";
import {ToNotify} from 'fast_inon';

const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Home = ({ lang, account }) => {
  const [message, Message] = useState('Salaam')
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(jdata);
/*
    const parent = document.getElementById("Header")
    if(parent) {
      parent.style.visibility = 'hidden'
      parent.style.height = 0 
    }
*/    
  }, []);

  //alert(landingPageData.Titles.services)
  return (
      
    <div className="App">
      <Navigation lang={lang} />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Team data={landingPageData.Team} />
      <Contact data={landingPageData.Contact} />
      <Gallery data={landingPageData.Gallery} />

      <ToNotify 
          message={message}
          onClose={()=>{Message('')}}
      />   

    </div>
  );
};

export default Home;


/*
<BrowserRouter>      <Routes>          <OnWhatsapp />        </Routes>      </BrowserRouter>
*/